/**
 * Minimalerei — Zepto Personalizer Guard
 *
 * Zepto's required-field-validation greift nur wenn Form-Fields im
 * DOM sind — das ist der Fall solange der Editor offen ist
 * (.pplr-c-button trägt dann die Klasse .pplr_remove).
 *
 * Wenn der Editor geschlossen ist (oder nie geöffnet wurde):
 * - Fängt diesen Guard den ATC-Klick im Capture-Phase ab
 * - Blockiert ihn + öffnet stattdessen den Editor
 *
 * Wenn der Editor offen ist → Zepto's eigene Validation übernimmt.
 *
 * Funktioniert auch wenn User Editor öffnet + Reset klickt + ATC
 * klickt (Editor wäre dann wieder zu → wird wieder geblockt).
 */

(function () {
  'use strict';

  const TRIGGER_SELECTOR = '.pplr-c-button';
  const ATC_SELECTOR = '.buy-box__atc';
  const EDITOR_OPEN_SELECTOR = '.pplr-c-button.pplr_remove';
  const PRODUCT_DATA_ID = 'mp-product-data';

  // ============================================================
  // ATC-Guard: ATC-Klick erzwingt Zepto-Editor wenn der nicht offen ist
  // ============================================================
  document.addEventListener('click', function (e) {
    const atc = e.target.closest(ATC_SELECTOR);
    if (!atc) return;
    if (!document.querySelector(TRIGGER_SELECTOR)) return;
    if (document.querySelector(EDITOR_OPEN_SELECTOR)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const openTrigger = document.querySelector('.pplr-c-button:not(.pplr_remove)');
    if (openTrigger) {
      openTrigger.click();
    }
  }, true);

  // ============================================================
  // PersonalisierenStart (Zepto) — sendet über mp-meta.js
  // ============================================================
  // Zustimmung, Pixel-Laden und Testmodus liegen jetzt zentral in
  // mp-meta.js (window.MpMeta). Diese Datei kann mit Zepto komplett
  // entfernt werden, ohne dass InteressierterBesuch oder die
  // Editor-Ereignisse etwas verlieren.

  function readProductData() {
    const el = document.getElementById(PRODUCT_DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.warn('[mp-pixel] mp-product-data JSON konnte nicht geparsed werden', err);
      return null;
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pplr-c-button:not(.pplr_remove)');
    if (!trigger) return;

    const product = readProductData();
    if (!product) return;

    // Session-Dedupe: ein Editor-Open pro Produkt und Besuch.
    // try/catch wegen privatem Modus (sessionStorage kann throwen).
    const key = 'mp_ps_' + product.id;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (err) {
      // Private-Mode: ohne Dedupe weiterfeuern — besser doppelt
      // als nie.
    }

    const eventId =
      'ps_' + product.id + '_' + Date.now() + '_' +
      Math.random().toString(36).slice(2, 8);

    // (1) Shopify Analytics (bleibt — nützt später für CAPI-Server-Pfad
    //     über dieselbe event_id).
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('personalisieren_start', {
        product_id: String(product.id),
        handle: product.handle,
        name: product.name,
        category: product.category,
        value: product.price,
        currency: 'EUR',
        event_id: eventId
      });
    }

    // (2) Meta über mp-meta.js (Zustimmung, Testmodus, eventID).
    if (window.MpMeta && typeof window.MpMeta.track === 'function') {
      window.MpMeta.track('PersonalisierenStart', {
        content_ids: [String(product.id)],
        content_name: product.name,
        content_type: 'product',
        content_category: product.category,
        value: product.price,
        currency: 'EUR'
      }, eventId);
    }
  }, true);

  // ============================================================
  // Variant-Change-Sync: Preis im mp-product-data JSON aktuell halten
  // ============================================================
  // Dawn's product-info.js publisht PUB_SUB_EVENTS.variantChange
  // nachdem die neue Variante geladen ist. Wir hängen uns dort ein
  // und updaten das price-Feld im JSON. So bleibt der gepublishte
  // Pixel-Event-Preis immer synchron zur aktuellen Auswahl.
  //
  // pubsub.js + constants.js werden via defer geladen, daher warten
  // wir bis subscribe/PUB_SUB_EVENTS verfügbar sind.
  function bindVariantChangeSync() {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) {
      return false;
    }
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (payload) {
      const variant = payload && payload.data && payload.data.variant;
      if (!variant || typeof variant.price !== 'number') return;
      const el = document.getElementById(PRODUCT_DATA_ID);
      if (!el) return;
      try {
        const obj = JSON.parse(el.textContent);
        obj.price = variant.price / 100;
        el.textContent = JSON.stringify(obj);
      } catch (err) {
        console.warn('[mp-pixel] variant-change JSON update fehlgeschlagen', err);
      }
    });
    return true;
  }

  if (!bindVariantChangeSync()) {
    // Pub-Sub noch nicht geladen → kurz polling, max 2s
    let tries = 0;
    const iv = setInterval(function () {
      if (bindVariantChangeSync() || ++tries > 20) clearInterval(iv);
    }, 100);
  }
})();
